import globals from '../../common/globals';
import vxSpinner from '../../common/vx-spinner/vx-spinner.vue';
import CheckoutService from '../../common/services/checkout-service';

import {
  Validator,
} from 'vee-validate';

export default {
  name: 'vx-guest-checkout',
  components: {
    vxSpinner,
  },
  props: {
    // Text coming from property file
    i18n: Object,
    // Indicates if guest checkout is enabled
    checkoutEnabled: Boolean,
  },
  data() {
    return {
      checkoutService: new CheckoutService(),
      globals,
      guestEmail: '',
    };
  },
  computed: {

  },
  mounted() {
    // Validation on email field
    const veeCustomErrorMessage = {
      en: {
        custom: {
          email: {
            required: this.i18n.emailRequiredError,
            email: this.i18n.emailInvalidError,
          },
        },
      },
    };
    Validator.localize(veeCustomErrorMessage);
  },
  methods: {
    /**
     * This function triggers the guest checkout call if there is a valid email id or sets the focus to email field to show email validation error
     */
    handleGuestCheckoutSubmit(event) {
      event.preventDefault();
      if (this.guestEmail) {
        if (this.checkoutEnabled) {
          this.guestEmail.toLowerCase();
          const el = document.querySelectorAll('.vx-guest-checkout input')[0];
          el.value = el.value.toLowerCase();
          this.$refs.guestForm.submit();
          // this.checkoutService.getGuestCheckout({}, this.handleGuestCheckoutResponse, this.handleGuestCheckoutError, this.guestEmail);
          this.$refs.spinner.showSpinner();
        }
      } else {
        this.globals.setFocusByName(this.$el, this.globals.getElementName(this.errors));
      }
    },
    /**
     * This function handles the success response of guest checkout call and navigates the user to checkout page
     */
    handleGuestCheckoutResponse() {
      this.$refs.spinner.hideSpinner();
      this.globals.navigateToUrl('checkout');
    },
    /**
     * This function handles the error of guest checkout
     */
    handleGuestCheckoutError(error) {
      this.$refs.spinner.hideSpinner();
    },
    hideServerError() {

    },
  },
};



// WEBPACK FOOTER //
// ./src/components/checkout/vx-guest-checkout/vx-guest-checkout.js